import { PayloadAction } from '@reduxjs/toolkit';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { ToggleChatReactionPayload } from 'features/chat/types';

export function* toggleChatReactionSaga(action: PayloadAction<ToggleChatReactionPayload>) {
  yield call(SignalingSocket.send, {
    event: 'toggleChatReaction',
    data: action.payload,
  });
}
